export default __webpack_public_path__ + "static/media/xlsx.574910a9.png";